import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast as myToast } from "react-toastify";
import catalogAPIs from "../api/catalogAPIs";

export const useCreateCatalog = (origin, onSuccessCallback) => {
  const navigate = useNavigate();
  const quaryClient = useQueryClient();
  return useMutation({
    mutationFn: catalogAPIs.createCatalog,
    onSuccess: (response) => {
      const { data } = response;
      const isSuccess = response.status === 200 || response.status === 201 || data?.status === 200;
      console.log("isSuccess===>",isSuccess)
      if (isSuccess) {
        quaryClient.invalidateQueries("catalogData");
        quaryClient.removeQueries("catalogCountData");
        sessionStorage.removeItem("createName");
        sessionStorage.setItem("catalogCreated", "true");
        if (onSuccessCallback) onSuccessCallback();
        navigate("/Catalog");
        myToast.success(data?.message || "Catalog created successfully!", {
          position: "top-right",
          autoClose: 2000,
        });
      } else {
        myToast.error(`Error: ${data?.message || "Failed to create catalog"}`, {
          position: "top-right",
          autoClose: 2000,
        });
      }
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message || error.message || "An error occurred";
      myToast.error(`Error: ${errorMessage}`, {
        position: "top-right",
        autoClose: 2000,
      });
    },
  });
};
